import { useMemo } from 'react';
import { sortAsc } from '@helpers/numHelpers';
import { RelatedItem, RelatedItemTag } from '@layouts/Related/Related.types';

interface UseRelatedDocFilterItemsProps {
  content: RelatedItem[];
  othersLabel: string;
  customTabText: string;
}

export const useRelatedDocFilterItems = ({
  content,
  othersLabel,
  customTabText,
}: UseRelatedDocFilterItemsProps) => {
  const filterItems = useMemo(() => {
    let filters: RelatedItemTag[] = [];
    let tags: RelatedItem[] = [];

    if (content) {
      tags = content.filter((item) => item.Tags);
    }

    /* Iterate all tags */
    tags.forEach(function (tag) {
      if (!tag.Tags) return;

      const docTags = Array.isArray(tag.Tags) ? tag.Tags : [tag.Tags];
      docTags?.forEach((item) => {
        if (item.id == null || item.name == null) {
          filters.push({ id: 'Other', name: othersLabel });
        } else {
          filters.push(item);
        }
      });
    });

    if (filters.length > 0) {
      const stringFilters = filters.map((item) => JSON.stringify(item));
      const uniqueStringFilters = new Set(stringFilters);
      filters = [];
      uniqueStringFilters.forEach((item) => filters.push(JSON.parse(item)));
      filters.sort(sortAsc);
      const index = filters.findIndex((x) => x.id === 'Other');
      filters.push(filters.splice(index, 1)[0]);
    }

    if (customTabText != null) {
      filters.push({ id: '001', name: customTabText });
    }
    return filters;
  }, [content, customTabText, othersLabel]);

  return filterItems;
};
